import React, { useState, useEffect } from "react";
import "./AgentLimitPage.css";
import { useLocalSearch } from "../../hooks/useLocalSearch";
import { useToast } from "../../components/Toast/ToastContainer";
const AgentLimitPage = () => {
    // State cho bộ lọc
    const [filters, setFilters] = useState({
        cifChuQuan: "",
        idDaiLy: "",
        cifDaiLy: "",
    });
    const toast = useToast();
    // State cho dữ liệu và phân trang
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [isLoading, setIsLoading] = useState(false);
    const { searchTerm, setSearchTerm, filteredData } = useLocalSearch(data);

    // Hàm format tiền tệ (VND)
    const formatCurrency = (value) => {
        if (!value) return "0";
        // Parse float để xử lý chuỗi "300000000.00" từ API
        return new Intl.NumberFormat('vi-VN').format(parseFloat(value));
    };

    // Hàm gọi API
    const fetchData = async (page = 1) => {
        setIsLoading(true);
        try {
            // Lấy token từ localStorage hoặc context (Cần thay thế bằng token thực tế của bạn)
            const token = localStorage.getItem("access_token");
            const payload = {
                parent_cif: filters.cifChuQuan || "", // Gửi chuỗi rỗng nếu không nhập
                agent_id: filters.idDaiLy || "",
                agent_cif: filters.cifDaiLy || "",
                page: page,
                page_size: pageSize
            };

            const response = await fetch('https://api.bvb.cybertech.com.vn/api/v1/admin/queries/agents/limits', {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error("Lỗi khi gọi API");
            }

            const result = await response.json();

            // Cập nhật data và tổng số bản ghi từ response
            setData(result.data || []);
            setTotalRecords(result.total || 0);
            setCurrentPage(page);

        } catch (error) {
            console.error("Failed to fetch data:", error);
            alert("Không thể tải dữ liệu. Vui lòng thử lại.");
        } finally {
            setIsLoading(false);
        }
    };

    // Gọi API lần đầu khi vào trang
    // useEffect(() => {
    //     fetchData(1);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };
    const handleSearch = () => {
        // Kiểm tra xem có ít nhất một trường filter được nhập hay không
        const hasFilter = Object.values(filters).some(value => value.trim() !== "");

        if (!hasFilter) {
            toast.error("Vui lòng nhập ít nhất một thông tin để tìm kiếm.");
            return;
        }

        fetchData(1);
    };

    const handleReset = () => {
        setFilters({ cifChuQuan: "", idDaiLy: "", cifDaiLy: "" });
        // Reset xong có thể gọi lại API để lấy list mặc định hoặc clear bảng tùy nghiệp vụ
        // Ở đây tôi sẽ reload lại dữ liệu gốc (trang 1, không filter)
        setTimeout(() => fetchData(1), 0);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= Math.ceil(totalRecords / pageSize)) {
            fetchData(newPage);
        }
    };

    // Tính toán số trang
    const totalPages = Math.ceil(totalRecords / pageSize);

    return (
        <div className="agent-limit-container">
            <h2 className="page-title">Truy vấn hạn mức Đại lý</h2>

            {/* FORM TÌM KIẾM */}
            <div className="filter-card">
                <div className="filter-grid">
                    <div className="filter-item">
                        <label>CIF chủ quản</label>
                        <input
                            type="text"
                            name="cifChuQuan"
                            value={filters.cifChuQuan}
                            onChange={handleChange}
                            placeholder="Nhập CIF chủ quản"
                        />
                    </div>

                    <div className="filter-item">
                        <label>ID Đại lý</label>
                        <input
                            type="text"
                            name="idDaiLy"
                            value={filters.idDaiLy}
                            onChange={handleChange}
                            placeholder="Nhập ID đại lý"
                        />
                    </div>

                    <div className="filter-item">
                        <label>CIF Đại lý</label>
                        <input
                            type="text"
                            name="cifDaiLy"
                            value={filters.cifDaiLy}
                            onChange={handleChange}
                            placeholder="Nhập CIF đại lý"
                        />
                    </div>
                </div>

                <div className="filter-actions">
                    <button className="btn-secondary" onClick={handleReset}>
                        Xóa lọc
                    </button>
                    <button className="btn-primary" onClick={handleSearch} disabled={isLoading}>
                        {isLoading ? "Đang tìm..." : "Tìm kiếm"}
                    </button>
                </div>
            </div>

            {/* KẾT QUẢ TÌM KIẾM */}
            <div className="result-header">
                <h3 className="result-title">Kết quả tìm kiếm</h3>
                {/* Phần search inline này chỉ là UI filter local giả định, nếu cần API search text thì cần sửa thêm */}
                <div className="search-inline">
                    <img src="/icons/icons8-search-100.png" alt="search icon" className="search-icon" />
                    <input
                        type="text"
                        placeholder="Tìm kiếm nhanh trong bảng..."
                        value={searchTerm} // 1. Gắn giá trị vào state
                        onChange={(e) => setSearchTerm(e.target.value)} // 2. Khi gõ thì cập nhật state
                    />
                </div>
            </div>

            {/* TABLE */}
            <div className="table-wrapper">
                <table className="result-table">
                    <thead>
                        <tr>
                            <th>CIF chủ quản</th>
                            <th>CIF Đại lý</th>
                            <th>ID Đại lý</th>
                            <th>HM ngày được cấp</th>
                            <th>HM ngày đã dùng</th>
                            <th>HM tháng được cấp</th>
                            <th>HM tháng đã dùng</th>
                        </tr>
                    </thead>

                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>Đang tải dữ liệu...</td>
                            </tr>
                        ) : filteredData.length > 0 ? (
                            filteredData.map((row, index) => (
                                <tr key={index}>
                                    {/* Map đúng field từ API response */}
                                    <td>{row.parent_cif}</td>
                                    <td>{row.agent_cif}</td>
                                    <td>{row.agent_id}</td>
                                    <td className="text-right">{formatCurrency(row.daily_limit)}</td>
                                    <td className="text-right">{formatCurrency(row.current_daily_usage)}</td>
                                    <td className="text-right">{formatCurrency(row.monthly_limit)}</td>
                                    <td className="text-right">{formatCurrency(row.current_monthly_usage)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                    {data.length > 0 && searchTerm
                                        ? "Không tìm thấy kết quả phù hợp"
                                        : "Không có dữ liệu"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* PAGINATION */}
            {totalRecords > 0 && (
                <div className="pagination">
                    <span>
                        {/* Format: [Số dòng hiện tại] / [Tổng số bản ghi] */}
                        Số lượng bản ghi: {filteredData.length}/{totalRecords} ({pageSize} bản ghi/trang)
                    </span>

                    <div className="pager">
                        <button
                            disabled={currentPage === 1 || isLoading}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Trước
                        </button>

                        {/* Hiển thị số trang hiện tại */}
                        <button className="active">{currentPage}</button>

                        <button
                            disabled={currentPage === totalPages || isLoading}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Sau
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AgentLimitPage;